export default defineNuxtRouteMiddleware((to, from) => {
	// Execute server-side check
	if (import.meta.server) {
		const headers = useRequestHeaders(['host'])
		const host = headers.host || ''
		const isStaging = host.endsWith('.vercel.app') || host.startsWith('staging-') || host.includes('localhost')
		if (!isStaging) {
			return navigateTo('/')
		}
	}
	// Execute client-side check
	else if (import.meta.client) {
		const host = window.location.host
		const isStaging = host.endsWith('.vercel.app') || host.startsWith('staging-') || host.includes('localhost')
		if (!isStaging) {
			return navigateTo('/')
		}
	}
})
